import { render, staticRenderFns } from "./ProductCardSwiper.vue?vue&type=template&id=a1453db6&"
import script from "./ProductCardSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductCardSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports